/**
 * @license @nomadreservations/ngx-codemirror
 * UNLICENSED
 * Copyright © 2017 Nomad Reservatoins, LLC. All Rights Reserved
 */

import { Component, EventEmitter, Injectable, Input, NgModule, NgZone, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReplaySubject as ReplaySubject$1 } from 'rxjs/ReplaySubject';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Main Codemirror import, utilizing window's existence to determine if we're server side or not.
 */
var CodeMirror$1 = typeof window !== 'undefined' && typeof window.navigator !== 'undefined'
    ? require('codemirror')
    : undefined;
/**
 * Initialize Event for CodeMirror.Editor instance
 *
 * Holds a referencable pointer to the code mirror instance for users.
 */
var CodemirrorService = /** @class */ (function () {
    function CodemirrorService() {
        /**
         * Codemirror instance subject
         *
         * Emits a refrence to the initialized CodeMirror.Editor once it's insantiated.
         */
        this.instance$ = new ReplaySubject$1();
    }
    CodemirrorService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    CodemirrorService.ctorParameters = function () { return []; };
    return CodemirrorService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// Imports
/**
 * Main Codemirror import, utilizing window's existence to determine if we're server side or not.
 */
var CodeMirror = typeof window !== 'undefined' && typeof window.navigator !== 'undefined'
    ? require('codemirror')
    : undefined;
/**
 * CodeMirror component
 *
 * **Usage** :
 * ```html
 *   <ngx-codemirror [(ngModel)]="data" [config]="{...}" (init)="onInit" (blur)="onBlur" (focus)="onFocus" ...></ngx-codemirror>
 * ```
 */
var CodemirrorComponent = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param _zone NgZone injected for Initialization
     */
    function CodemirrorComponent(_codeMirror, _zone) {
        this._codeMirror = _codeMirror;
        this._zone = _zone;
        /**
         * change output event, pass through from codemirror
         */
        this.change = new EventEmitter();
        /**
         * focus output event, pass through from codemirror
         */
        this.focus = new EventEmitter();
        /**
         * blur output event, pass through from codemirror
         */
        this.blur = new EventEmitter();
        /**
         * cursorActivity output event, pass through from codemirror
         */
        this.cursorActivity = new EventEmitter();
        /**
         * Value storage
         */
        this._value = '';
    }
    Object.defineProperty(CodemirrorComponent.prototype, "value", {
        /** Implements ControlValueAccessor.value */
        get: /**
         * Implements ControlValueAccessor.value
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * Implements ControlValueAccessor.value
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v !== this._value) {
                this._value = v;
                this.onChange(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * On component destroy
     * @return {?}
     */
    CodemirrorComponent.prototype.ngOnDestroy = /**
     * On component destroy
     * @return {?}
     */
    function () {
    };
    /**
     * On component view init
     * @return {?}
     */
    CodemirrorComponent.prototype.ngAfterViewInit = /**
     * On component view init
     * @return {?}
     */
    function () {
        this.config = this.config || {};
        this.codemirrorInit(this.config);
    };
    /**
     * Value update process
     * @param {?} value
     * @return {?}
     */
    CodemirrorComponent.prototype.updateValue = /**
     * Value update process
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        this.onTouched();
        this.change.emit(value);
    };
    /**
     * Implements ControlValueAccessor
     * @param {?} value
     * @return {?}
     */
    CodemirrorComponent.prototype.writeValue = /**
     * Implements ControlValueAccessor
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._value = value || '';
        if (this._instance) {
            this._instance.setValue(this._value);
        }
    };
    /**
     * Change event trigger
     * @param {?} _
     * @return {?}
     */
    CodemirrorComponent.prototype.onChange = /**
     * Change event trigger
     * @param {?} _
     * @return {?}
     */
    function (_) { };
    /**
     * Dirty/touched event trigger
     * @return {?}
     */
    CodemirrorComponent.prototype.onTouched = /**
     * Dirty/touched event trigger
     * @return {?}
     */
    function () { };
    /**
     * Implements ControlValueAccessor.registerOnChange
     * @param {?} fn
     * @return {?}
     */
    CodemirrorComponent.prototype.registerOnChange = /**
     * Implements ControlValueAccessor.registerOnChange
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * Implements ControlValueAccessor.registerOnTouched
     * @param {?} fn
     * @return {?}
     */
    CodemirrorComponent.prototype.registerOnTouched = /**
     * Implements ControlValueAccessor.registerOnTouched
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * Initialize codemirror
     * @param {?} config
     * @return {?}
     */
    CodemirrorComponent.prototype.codemirrorInit = /**
     * Initialize codemirror
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        if (CodeMirror) {
            this._zone.runOutsideAngular(function () {
                _this._instance = CodeMirror.fromTextArea(_this.host.nativeElement, config);
                _this._instance.setValue(_this._value);
            });
            this._instance.on('change', function () {
                _this.updateValue(_this._instance.getValue());
            });
            this._instance.on('focus', function (instance, event) {
                _this.focus.emit({ instance: instance, event: event });
            });
            this._instance.on('cursorActivity', function (instance) {
                _this.cursorActivity.emit({ instance: instance });
            });
            this._instance.on('blur', function (instance, event) {
                _this.blur.emit({ instance: instance, event: event });
            });
            this._codeMirror.instance$.next(this._instance);
        }
    };
    CodemirrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-codemirror',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            // tslint:disable-next-line:no-forward-ref
                            useExisting: forwardRef(function () { return CodemirrorComponent; }),
                            multi: true
                        }
                    ],
                    template: '<textarea #host></textarea>',
                },] },
    ];
    /** @nocollapse */
    CodemirrorComponent.ctorParameters = function () { return [
        { type: CodemirrorService, },
        { type: NgZone, },
    ]; };
    CodemirrorComponent.propDecorators = {
        "config": [{ type: Input },],
        "change": [{ type: Output },],
        "focus": [{ type: Output },],
        "blur": [{ type: Output },],
        "cursorActivity": [{ type: Output },],
        "host": [{ type: ViewChild, args: ['host',] },],
        "value": [{ type: Input },],
    };
    return CodemirrorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * \@angular 5.x+ SSR ready CodeMirror wrapping module.
 */
var CodemirrorModule = /** @class */ (function () {
    function CodemirrorModule() {
    }
    CodemirrorModule.decorators = [
        { type: NgModule, args: [{
                    providers: [
                        CodemirrorService
                    ],
                    declarations: [CodemirrorComponent],
                    exports: [CodemirrorComponent],
                    entryComponents: [CodemirrorComponent]
                },] },
    ];
    /** @nocollapse */
    CodemirrorModule.ctorParameters = function () { return []; };
    return CodemirrorModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { CodemirrorModule, CodemirrorComponent, CodemirrorService };
//# sourceMappingURL=ngx-codemirror.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@nomadreservations/ngx-codemirror/esm5/ngx-codemirror.js
// module id = 248
// module chunks = 0